module.exports = __webpack_public_path__ + "static/media/sf-test-16.3ded695c.mp3";